import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-student-view-attendance-history",
	templateUrl: "./student-view-attendance-history.component.html",
	styleUrls: ["./student-view-attendance-history.component.css"],
})
export class StudentViewAttendanceHistoryComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef) {}

	ngOnInit(): void {
		this.SelectedAttendanceHistory = this.dialogConfig.data.SelectedAttendanceHistory;

		this.StudentID = this.SelectedAttendanceHistory.StudentID;
		this.StudentName = this.SelectedAttendanceHistory.StudentName;
		this.DateTime = this.SelectedAttendanceHistory.EntryDTDesc;
		this.Status = this.SelectedAttendanceHistory.RecordStatusDesc;
		this.Excuse = this.SelectedAttendanceHistory.ExcuseDes;
		this.EntryType = this.SelectedAttendanceHistory.EntryTypeDesc;
		this.ScanStation = this.SelectedAttendanceHistory.ScanStation;
		this.ModifiedDate = this.SelectedAttendanceHistory.c_dateDesc;
		this.ModifiedBy = this.SelectedAttendanceHistory.AdminName;
		this.RecordStatus = this.SelectedAttendanceHistory.RecordStatusDesc;
		this.Comments = this.SelectedAttendanceHistory.c_Comment;
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	//Input
	SelectedAttendanceHistory: any;

	//Display
	StudentID: any = "";
	StudentName: any = "";
	DateTime: any = "";
	Status: any = "";
	Excuse: any = "";
	EntryType: any = "";
	ScanStation: any = "";
	ModifiedDate: any = "";
	ModifiedBy: any = "";
	RecordStatus: any = "";
	Comments: any = "";

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////

	onClose() {
		this.ref.close(0);
	}

	///////////////////////////////////////////////////////
}
